import { render, staticRenderFns } from "./OcorrenciasInternas.vue?vue&type=template&id=59106854"
import script from "./OcorrenciasInternas.vue?vue&type=script&lang=js"
export * from "./OcorrenciasInternas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports